import React from 'react';
import { useDispatch } from 'react-redux';

import { useTypedSelector } from 'hooks/use-typed-selector';
import { NumberOption } from 'interfaces/forms/types';
import { ReactSelect } from 'components/form/field/react_select';

interface ICustomerDropdownPropsRaw {
  selectedCustomerId: number;
  setSelectedCustomerId: (customerId: any) => void;
  isLabelOn?: boolean;
  isSelectedOption?: boolean;
  isMulti?: boolean;
  disableAllOption?: boolean;
  isDisabled?: boolean;
  ctrlProps: any;
  defaultValue?: NumberOption[];
  filteredCustomers?: NumberOption[];
}

export const CustomerDropdownRaw: React.FC<ICustomerDropdownPropsRaw> = (
  props: ICustomerDropdownPropsRaw,
): JSX.Element => {
  const [pristine, setPristine] = React.useState<boolean>(true);

  const customers = useTypedSelector(state => state.filters.customers);

  const allCustomers = customers.map<NumberOption>(x => ({
    label: x.name,
    value: x.id,
  }));
  const useIsMulti = props.isMulti || false;
  const useIsDisabled = props.isDisabled || false;

  const calcValue = (val: any) => {
    const defaultAll =
      props && props.defaultValue && props.defaultValue.length > 0
        ? props.defaultValue
        : [{ label: 'All', value: -1 }];

    if (!Array.isArray(val) && !useIsMulti) {
      return [val];
    }
    if (
      (!Array.isArray(val) ||
        (Array.isArray(props.defaultValue) && props.defaultValue.length === 0)) &&
      useIsMulti &&
      pristine
    ) {
      return defaultAll;
    }
    if (!useIsDisabled) {
      const filteredVal = val.filter((v: { label: string; value: number }) => v.value !== -1);
      if (useIsMulti && val.length === 0) {
        return defaultAll;
      }

      return filteredVal;
    }
    if (useIsDisabled && val && val.length > 0) {
      return [...val];
    }

    return defaultAll;
  };

  const calcLabel = () => {
    if (props.isLabelOn) {
      return useIsMulti ? 'Customers' : 'Customer';
    }
    return undefined;
  };

  return (
    <ReactSelect
      value={calcValue(props.ctrlProps?.field?.value)}
      fields={props.filteredCustomers || allCustomers}
      isMulti={useIsMulti}
      isDisabled={useIsDisabled}
      label={calcLabel()}
      handleOnChange={(value: any) => {
        const filteredVal = useIsMulti
          ? value.filter((v: { label: string; value: number }) => v.value !== -1)
          : value.value;
        setPristine(false);
        props.setSelectedCustomerId(filteredVal);
      }}
    />
  );
};

export default CustomerDropdownRaw;
